export default __webpack_public_path__ + "static/media/store.939e5d2a.svg";